
/* LOVELEE DAE - Direct Quick Add */

document.addEventListener('click', async (event) => {
  const button = event.target.closest('.lld-quick-add__size');

  if (!button || button.disabled) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = Number(button.dataset.lldVariantId);
  if (!variantId || button.classList.contains('is-loading')) return;

  const quickAdd = button.closest('.lld-quick-add');
  const buttons = quickAdd.querySelectorAll('button');

  buttons.forEach(item => item.disabled = true);
  button.classList.add('is-loading');

  let added = false;

  try {
    const drawer = document.querySelector('cart-drawer');

    const sectionIds = drawer?.getSectionsToRender?.()
      .map(section => section.section) || [];

    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }],
        sections: sectionIds,
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.description || 'Toevoegen mislukt');
    }

    added = true;

    if (drawer && data.sections && sectionIds.length) {
      drawer.renderContents(data, true);

      if (typeof updateFreeShipping === 'function') {
        updateFreeShipping();
      }
    } else {
      window.location.href = root + 'cart';
    }

  } catch (error) {
    console.error('LLD Quick Add:', error);

    if (added) {
      window.location.href =
        (window.Shopify?.routes?.root || '/') + 'cart';
    } else {
      alert(error.message || 'Probeer het opnieuw.');
    }
  } finally {
    buttons.forEach(item => {
      if (!item.hasAttribute('data-lld-unavailable')) {
        item.disabled = false;
      }
    });

    button.classList.remove('is-loading');
  }
});

/* Open of sluit maatselectie via plusknop */

document.addEventListener('click', function(event) {
  const toggle = event.target.closest('.lld-quick-add__toggle');

  if (toggle) {
    event.preventDefault();
    event.stopPropagation();

    const quickAdd = toggle.closest('.lld-quick-add');

    const isOpen = quickAdd.classList.toggle('is-open');

    toggle.setAttribute('aria-expanded', String(isOpen));
  }
});

/* Sluit maatselectie bij klik buiten product */

document.addEventListener('click', function(event) {
  document.querySelectorAll('.lld-quick-add.is-open').forEach(quickAdd => {
    if (!quickAdd.contains(event.target)) {
      quickAdd.classList.remove('is-open');

      const toggle = quickAdd.querySelector('.lld-quick-add__toggle');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
  });
});